// 商品分类dlg组件

const goodTypeDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    goodTypeId: '',

    goodTypeName: '',
  },

  getters: {
    dlgShow: state => state.dlgShow,

    goodTypeId: state => state.goodTypeId,

    goodTypeName: state => state.goodTypeName,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_GOODTYPEID: (state, val) => {
      state.goodTypeId = val
    },

    SET_GOODTYPENAME: (state, val) => {
      state.goodTypeName = val
    },
  },

  actions: {

  }
}

export default goodTypeDlg
